import React from "react";
import "./App.css";

import ChakraProvider from "./providers/ChakraProvider";
import AppLayout from "./layouts/AppLayout";
import AppRouter from "./routes";
import { HelmetProvider } from "react-helmet-async";

function App(): React.JSX.Element {
  return (
    <HelmetProvider context={{}}>
      <ChakraProvider>
        <AppLayout>
          <AppRouter />
        </AppLayout>
      </ChakraProvider>
    </HelmetProvider>
  );
}

export default App;
